<template>
  <div class="top-navigation">
    <div class="page-sections" v-if="!$_kioskMode">
      <div class="page-section havet">
        <a href="https://www.havet.nu" target="_blank" rel="noopener noreferrer"
          >Havet.nu</a
        >
      </div>
      <div class="page-section livet active">
        <a
          href="https://www.havet.nu/livet"
          target="_blank"
          rel="noopener noreferrer"
          >Livet i havet</a
        >
      </div>
      <div class="page-section havsutsikt">
        <a href="https://www.havet.nu/havsutsikt">Havsutsikt</a>
      </div>
    </div>
    <div></div>
    <div class="container">
      <div class="hamburger" v-if="$vuetify.breakpoint.smAndDown">
        <v-app-bar-nav-icon
          color="white"
          @click.stop="$store.dispatch('setNavigationdrawerVisibility', true)"
        ></v-app-bar-nav-icon>
      </div>
      <div class="row-1">
        <img
          :src="logoImage"
          alt="logo"
          :class="[
            'logotype',
            { 'logotype-sm': $vuetify.breakpoint.smAndDown }
          ]"
          @click="
            $router.push({
              name: 'Home'
            })
          "
        />
        <div
          :class="['tagline', { 'tagline-sm': $vuetify.breakpoint.mdAndDown }]"
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          Växter och djur i våra hav
        </div>
      </div>
      <div class="input-search-container">
        <input
          type="text"
          name="q"
          class="form-control mb-2"
          placeholder="Sök efter växter och djur i våra hav"
          aria-describedby="search"
          v-model="search"
          @keydown="sendSearch"
        /><button class="seach-button" aria-label="Search" @click="sendSearch">
          Sök
        </button>
      </div>
      <div class="links" v-if="$vuetify.breakpoint.mdAndUp">
        <span v-for="(link, i) in links" :key="i" @click="link.action">{{
          link.title
        }}</span>
        <GeoSelect>
          <v-btn outlined color="#fff" rounded lighten-2>
            <v-icon left>
              mdi-map-marker
            </v-icon>
            Arter i
            {{ $_currentGeoSectionExtra }}
          </v-btn>
        </GeoSelect>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import GeoSelect from '@/components/GeoSelect.vue'
import GeoStuff from '@/mixins/GeoStuff.js'
import Misc from '@/mixins/Misc.js'
import logoImage from '@/assets/livetihavet_logo_vit.svg'
export default {
  name: 'TopNav',
  components: {
    GeoSelect
  },
  mixins: [GeoStuff, Misc],

  data() {
    return {
      logoImage,
      search: '',
      links: [
        {
          title: 'Arter',
          action: () =>
            this.$router.push({
              name: 'Species'
            })
        },
        {
          title: 'Livsmiljöer',
          action: () =>
            this.$router.push({
              name: 'Livsmiljoer'
            })
        },
        {
          title: 'Faktasidor',
          action: () =>
            this.$router.push({
              name: 'Fakta'
            })
        },
        {
          title: 'Om Livet i Havet',
          action: () => this.$router.push({ name: 'om-livet' })
        },
        {
          title: 'Redaktionen',
          action: () => this.$router.push({ name: 'redaktion' })
        },

        {
          title: 'Meny',
          action: () =>
            this.$store.dispatch('setNavigationdrawerVisibility', true)
        }
      ]
    }
  },
  methods: {
    sendSearch(e) {
      if (e.type === 'keydown') {
        if (e.key === 'Enter') {
          this.$router.push({ name: 'Search', query: { q: this.search } })
        }
      } else {
        this.$router.push({ name: 'Search', query: { q: this.search } })
      }
    }
  }
}
</script>

<style scoped>
.top-navigation {
  background: rgb(33, 162, 97);
  background: url(https://havetstore.blob.core.windows.net/bilder/livet-pwa/bakgrund.png)
    repeat;
  display: grid;
  grid-template-columns: 1fr 7fr 1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 0px;
  grid-row-gap: 0px;
  position: relative;
}
.container {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  padding: 10px 0;
}
.page-sections {
  position: absolute;
  right: 20px;
  top: -1px;
  display: flex;
}
.page-section {
  padding: 5px 20px 8px;
  background-color: #21a261;
  border: #1a814d 1px solid;
  font-size: 14px;
  border-radius: 0 0 10px 10px;
  color: #fff;
  font-weight: 500;
}
.page-section a {
  font-size: 14px;
  color: #fff;
  text-decoration: none;
}
.page-section.active {
  z-index: 2;
  background-color: #fff;
  border: #fff 1px solid;
}
.page-section.active a {
  color: #21a261;
}
.page-section.havet {
  transform: translate(6px);
}
.page-section.livet {
  transform: translate(3px);
}
.page-section.havsutsikt {
}

.row-1 {
  justify-content: flex-start;
  gap: 20px;
  display: flex;
  align-items: center;
}

.row-1 .tagline {
  line-height: 1.5;
  text-align: left;
  box-sizing: border-box;
  display: block !important;
  font-size: 21px;
  color: #fff;
  font-weight: 300;
  /* font-family: poppins, sans-serif; */
  margin-top: 10px;
}

.tagline-sm {
  margin-top: 25px;
}

.input-search-container {
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  font-family: Poppins, sans-serif;
  color: #444;
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
}
.input-search-container input {
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased !important;
  box-sizing: border-box;
  margin: 0;
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-clip: padding-box;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 0;
  box-shadow: none;
  position: relative;
  flex: 1;
  min-width: 0;
  border: none;
  background-color: #addfc4;
  height: 45px;
}

.input-search-container button {
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased !important;
  box-sizing: border-box;
  margin: 0 -1px 0 0;
  overflow: visible;
  appearance: button;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  white-space: nowrap;
  height: 45px;
  cursor: pointer;
  text-transform: uppercase;
  border: none;
  border-radius: 0;
  color: #333;
  background-color: #6bc197;
  padding: 0 18px;
}

.links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
}

.links span {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
}

.logotype {
  width: 200px;
  margin-left: -10px;
  cursor: pointer;
}
.logotype-sm {
  width: 150px;
  margin-top: 30px;
  margin-bottom: 10px;
}
.hamburger {
  position: absolute;
  right: 16px;
  top: 48px;
}
</style>
